


























































import {Component, Vue, Watch} from 'vue-property-decorator';
import Tree from '@/components/Tree.vue';
import {TreeUtils} from '@/components/utils/TreeUtils';
import {STreeData} from '@/components/dto/STreeData';
import {STreeItem, STreeItemImpl} from "@/components/dto/STreeItem";
import {scroller} from 'vue-scrollto/src/scrollTo';
import SearchTreeItem from "@/components/SearchTreeItem.vue";
import XmlTree from "@/components/XmlTree.vue";
import {SXMLTreeData} from "@/components/dto/SXMLTreeData";
import {SPropTypeEnum} from "@/components/dto/SPropTypeEnum";
import xmlParse from "xml-parser-xo";

@Component({
   components: {XmlTree, SearchTreeItem, Tree}
})
export default class Formatter extends Vue {
    private insertData: string = '';
    private trees : STreeData = {type: SPropTypeEnum.SNULL ,treeItems: []};
    private xmlDom: SXMLTreeData | null = null;
    private treeRootKeyRefresh: number = 0;
    private openModal: boolean = false;
    private errorInputText: any = null;
    private validation: boolean = false;
    private parser = new DOMParser();
    private searchItemId: string = "";
    private countInsertCode: number = 0;

    created() {
      this.insertData = this.$store.getters.formatData;
      if(this.validated(this.insertData)){
        if(this.insertData === '') {
          this.insertData = '{}';
        }
        this.formatInput();
      }

    }

  get treeRootKey(){
      return `treeRootKey-${this.treeRootKeyRefresh}`;
    }
    refreshRoot(){
      this.treeRootKeyRefresh +=1;
    }

    insertCode(){
      this.insertData = '';
      this.xmlDom = null;
      this.openModal = true;

    }

    formatInput(): void{
        if(this.xmlDom !== null){
          this.trees.treeItems = TreeUtils.createXmlTreeItem(this.xmlDom, true);
        }else{
          const data = JSON.parse(this.insertData);
          let dataType: SPropTypeEnum = SPropTypeEnum.SOBJECT;
          if (data instanceof Array) {
            dataType = SPropTypeEnum.SARRAY;
          }
          this.trees.treeItems = TreeUtils.createTreeItem(JSON.parse(this.insertData), true);
          this.trees.type= dataType;
        }
        this.countInsertCode += 1;
    }

    selectedItemOption(item : STreeItem){
      this.filterChildTree(item, this.trees.treeItems);
      this.searchItemId = item.itemId;
      if(this.searchItemId != "") {
        const firstScrollTo = scroller();
        firstScrollTo(`#tools-${this.searchItemId}`);
        this.searchItemId = "";
      }
    }


    filterChildTree(findItem: STreeItem, item: STreeItem[]){
      item.map(i => {
        if(i.itemId === findItem.parentId){
          i.isOpen = true;
          i.propChildren.find(i => {
            if (i.itemId === findItem.itemId) {
              i.isFinded = true;
            }else {
              i.isFinded = false;
            }
          })
          if(i.itemId === findItem.itemId){
            i.isFinded = true;
          }else {
            i.isFinded = false;
          }
          if(i.parentId !== 'root'){
            i.isFinded = false;
            this.filterChildTree(i, this.trees.treeItems);
          }
        }else {
          i.isFinded = false;
          this.filterChildTree(findItem, i.propChildren);
        }
      });
    }

    @Watch('insertData')
    watchText(newInsertData: string){
      this.validation = this.validated(newInsertData);
    }
    validated(insertData: string){
      if(insertData === "") return false;
      let valid: boolean = false;
      try{
          JSON.parse(insertData);
        valid = true;
      }catch (e){
        this.errorInputText = e;
        this.openModal = true;
        valid = false;
      };
      // if(!valid) {
      //   try {
      //     this.xmlDom = xmlParse(insertData);
      //     valid = true;
      //   } catch (e) {
      //     this.errorInputText = e;
      //     this.openModal = true;
      //     valid = false;
      //   };
      // }
      return valid;
    }
}
